
export const GALLERY_DATA = {
  /* ─── Categories / Tabs ─── */
  categories: ['All', 'Ekatva Fest', 'Titiksha Fest', 'Cultural Nights', 'Dance & Music', 'Campus Life', 'Official'],

  /* ─── Images — Add real event photos here during the fest ─── */
  images: [
    { id: 'img-1', src: '/assests/Images/ekatva2025.jpeg', caption: 'Ekatva 2025 — Highlights', category: 'Ekatva Fest', featured: true },
    { id: 'img-2', src: '/assests/Images/ekatva2025-1.jpeg', caption: 'Ekatva 2025 — Smart solutions hackathon', category: 'Ekatva Fest', featured: true },
    { id: 'img-3', src: '/assests/Images/ekatva2025-3.jpeg', caption: 'Ekatva 2025 — discipline Committee', category: 'Ekatva Fest', featured: false },
  ],

  /* ─── YouTube Videos — Real SMVDU / Ekatva / Titiksha content ─── */
  videos: [
    // ── Ekatva Fest ──
   
    { id: 'vid-1',  youtubeId: 'mG5L8j0ZEv0', title: 'Honourable Vice Chancellor Invitation to Ekatva',                       category: 'Official',       featured: true },
     { id: 'vid-2', youtubeId: 'lrQkNlvMWVo', title: '8th Convocation — Shri Mata Vaishno Devi University',                   category: 'Official',       featured: true },
    
    { id: 'vid-3', youtubeId: 'iLzZiANGgmE', title: '75th Republic Day Celebrated at SMVDU',                                  category: 'Official',       featured: true },
    { id: 'vid-5',  youtubeId: 'vRYd0ka9qmY', title: "EKATVA'25 (SMVDU Fest) — Part 2",                                      category: 'Ekatva Fest',    featured: false },
    { id: 'vid-4', youtubeId: 'aZmBfSE-sUQ', title: '75th Republic Day Celebrated at SMVDU',                                  category: 'Official',       featured: false },
   
   
  ],
};
